export enum SettingsSdkKeys {
    Direction = "next.ecommerce.direction",
    Realm = "next.ecommerce.realmName",
    Territory = "next.ecommerce.territoryName",
    Language = "next.ecommerce.languageName",
    CorrelationHeaderName = "x-next-correlation-id",
    imageCdnUrl = "next.ecommerce.productsummary.frontend.imageCdnUrl",
    appCache = "next.ecommerce.productsummary.frontend.appCacheTTL",
    textData = "next.ecommerce.productsummary.frontend.textData",
    // PBI 417565 - To be removed once using @next/themes & @next/theme-provider is retired.
    ThemeVersion = "next.ecommerce.productsummary.frontend.themeVersion",
    cacheControl = "next.ecommerce.productsummary.frontend.cache-control.max-age",
    cacheControlForColourwaysApi = "next.ecommerce.productsummary.frontend.cache-control.max-age.colourways-api",
    cacheControlDefault = "next.ecommerce.productsummary.frontend.cache-control.default-productsummary.max-age",
    saleSash = "next.ecommerce.productsummary.frontend.saleSash",
    saleSashPosition = "next.ecommerce.productsummary.frontend.saleSashPosition",
    lazyLoadConfig = "next.ecommerce.productsummary.frontend.lazyloadConfig",
    enableSearchDescription = "next.ecommerce.productsummary.frontend.enableSearchDescription",
    enableCenteredContent = "next.ecommerce.productsummary.frontend.enableCenteredContent",
    mobileThumbnailConfig = "next.ecommerce.productsummary.frontend.mobileThumbnailConfig",
    lazySizesConfig = "next.ecommerce.productsummary.frontend.lazySizesConfig",
    maxNumberOfSofaColourways = "next.ecommerce.productsummary.frontend.maxNumberOfSofaColourways",
    maxNumberOfHomewareColourways = "next.ecommerce.productsummary.frontend.maxNumberOfHomewareColourways",
    brandedMarkdownSalePrice = "next.ecommerce.productsummary.frontend.brandedMarkdownSalePrice",
    displayFitIcons = "next.ecommerce.productsummary.frontend.displayFitIcons",
    displayNewIn = "next.ecommerce.productsummary.frontend.displayNewIn",
    EnableSingleLineBrandName = "next.ecommerce.productsummary.frontend.enableSingleLineBrandName",
    RemoveBrandNameInTitle = "next.ecommerce.productsummary.frontend.removeBrandNameInTitle",
}

export const BASELINECSS_GENERATE_CSS_ITEM_NUMBER = "GENERATE_CSS_ONLY"
export const BASELINECSS_MATERIALUI = "materialui"
export const BASELINECSS_CUSTOM = "custom"

export const QUERY_PARAMETER_NEW_IN = "show-new-in"
export const QUERY_PARAMETER_TYPE = "type"
export const QUERY_PARAMETER_IMAGE_RATIO = "image-ratio"
